module.exports = __webpack_public_path__ + "static/media/unemployment_total.bb1b5cf4.png";